import { globalStyle, style } from '@vanilla-extract/css';

export const carouselContainer = style({
  position: 'relative',
  width: 'var(--carousel-width, 100%)',
  display: 'flex',
  flexDirection: 'column',
  gap: 'var(--carousel-gap, 1rem)',
  padding: 'var(--carousel-padding)',
  '@media': {
    '(max-width: 767px)': {
      width: 'var(--carousel-width-mobile, var(--carousel-width, 100%))',
      gap: 'var(--carousel-gap-mobile, var(--carousel-gap, 0.5rem))',
      padding: 'var(--carousel-padding-mobile, var(--carousel-padding))',
    },
  },
});

export const carouselContainerRow = style({
  flexDirection: 'row',
  alignItems: 'flex-start',
});

globalStyle(`${carouselContainerRow} > *:first-child`, {
  flex: 1,
});

export const carouselContainerRowReverse = style({
  flexDirection: 'row-reverse',
  alignItems: 'flex-start',
});

globalStyle(`${carouselContainerRowReverse} > *:first-child`, {
  flex: 1,
});

export const carouselContainerColumnReverse = style({
  flexDirection: 'column-reverse',
});

export const carouselViewportWrapper = style({
  position: 'relative',
  minWidth: 0,
  overflow: 'hidden',
  borderRadius: 'var(--carousel-border-radius, 12px)',
});

export const carouselViewport = style({
  overflow: 'hidden',
  width: '100%',
});

export const carouselSlidesContainer = style({
  display: 'flex',
  touchAction: 'pan-y pinch-zoom',
});

export const carouselSlide = style({
  flex: '0 0 100%',
  minWidth: 0,
  overflow: 'hidden',
});

export const carouselArrow = style({
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  zIndex: 10,
  width: '32px',
  height: '32px',
  backgroundColor: 'var(--carousel-arrow-color, var(--accent))',
  borderRadius: '6px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: 'none',
  cursor: 'pointer',
  transition: 'opacity 0.2s ease',
  color: 'var(--carousel-arrow-icon-color, #ffffff)',
  boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.05)',
  '@media': {
    '(min-width: 768px)': {
      width: '40px',
      height: '40px',
      borderRadius: '8px',
    },
  },
  selectors: {
    '&:disabled': {
      opacity: 0.5,
      cursor: 'default',
    },
    '&:hover:not(:disabled)': {
      opacity: 0.9,
    },
  },
});

export const carouselArrowPrev = style({
  left: '0.75rem',
  '@media': {
    '(min-width: 768px)': {
      left: '1.5rem',
    },
  },
});

export const carouselArrowNext = style({
  right: '0.75rem',
  '@media': {
    '(min-width: 768px)': {
      right: '1.5rem',
    },
  },
});

export const carouselControls = style({
  position: 'absolute',
  bottom: '1.5rem',
  left: '50%',
  transform: 'translateX(-50%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0.5rem',
  zIndex: 10,
});

export const carouselDot = style({
  width: '8px',
  height: '8px',
  borderRadius: '50%',
  backgroundColor: 'var(--carousel-dot-color, rgba(255, 255, 255, 0.4))',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
  transition: 'background-color 0.2s ease',
});

export const carouselDotActive = style({
  backgroundColor: 'var(--carousel-dot-active-color, #ffffff)',
});

export const carouselNumbersContainer = style({
  backgroundColor: 'var(--carousel-counter-bg, rgba(17, 24, 39, 0.5))',
  paddingLeft: '12px',
  paddingRight: '12px',
  paddingTop: '4px',
  paddingBottom: '4px',
  borderRadius: '6px',
});

export const carouselNumbers = style({
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '20px',
  color: 'var(--carousel-counter-text, #ffffff)',
  fontVariantNumeric: 'tabular-nums',
});

export const carouselThumbnails = style({
  display: 'flex',
  gap: 'var(--thumbnail-gap, 1rem)',
  overflowX: 'auto',
  paddingBottom: '0.25rem',
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
  WebkitOverflowScrolling: 'touch',
  selectors: {
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  '@media': {
    '(max-width: 767px)': {
      gap: 'var(--thumbnail-gap-mobile, var(--thumbnail-gap, 0.5rem))',
    },
  },
});

export const carouselThumbnailsVertical = style({
  flexDirection: 'column',
  overflowX: 'visible',
  overflowY: 'auto',
  paddingBottom: 0,
  paddingRight: '0.25rem',
  height: 'var(--thumbnail-container-height, 400px)',
  maxHeight: 'var(--thumbnail-container-height, 400px)',
});

export const carouselThumbnail = style({
  height: 'var(--thumbnail-height, 80px)',
  aspectRatio: 'var(--thumbnail-aspect-ratio, 1.9 / 1)',
  borderRadius: 'var(--thumbnail-border-radius, 8px)',
  overflow: 'hidden',
  cursor: 'pointer',
  border: '2px solid transparent',
  transition: 'border-color 0.2s ease',
  flexShrink: 1,
  minWidth: '60px',
  '@media': {
    '(max-width: 767px)': {
      height: 'var(--thumbnail-height-mobile, 56px)',
      borderRadius: 'var(--thumbnail-border-radius-mobile, var(--thumbnail-border-radius, 6px))',
      minWidth: '40px',
    },
  },
});

export const carouselThumbnailActive = style({
  borderColor: 'var(--carousel-arrow-color, var(--accent))',
});

export const carouselThumbnailImg = style({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
});

globalStyle(`${carouselSlide} img`, {
  width: '100%',
  height: 'auto',
  display: 'block',
});

globalStyle(`${carouselViewportWrapper} img`, {
  borderRadius: 'var(--carousel-border-radius, 12px)',
});

export const gridContainer = style({
  display: 'grid',
  gap: 'var(--grid-gap, 1rem)',
  width: 'var(--carousel-width, 100%)',
  padding: 'var(--carousel-padding)',
  '@media': {
    '(max-width: 767px)': {
      width: 'var(--carousel-width-mobile, var(--carousel-width, 100%))',
      gap: 'var(--grid-gap-mobile, var(--grid-gap, 0.5rem))',
      padding: 'var(--carousel-padding-mobile, var(--carousel-padding))',
    },
  },
});

export const gridOneColumn = style({
  gridTemplateColumns: '1fr',
});

export const gridTwoColumns = style({
  gridTemplateColumns: 'repeat(2, 1fr)',
});

export const gridMobileOneColumn = style({
  '@media': {
    '(max-width: 767px)': {
      gridTemplateColumns: '1fr',
    },
  },
});

export const gridMobileTwoColumns = style({
  '@media': {
    '(max-width: 767px)': {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
  },
});

export const hideOnMobile = style({
  '@media': {
    '(max-width: 767px)': {
      display: 'none',
    },
  },
});

export const hideOnDesktop = style({
  display: 'none',
  '@media': {
    '(max-width: 767px)': {
      display: 'flex',
    },
  },
});

export const hideOnDesktopThumbnails = style({
  display: 'none',
  '@media': {
    '(max-width: 767px)': {
      display: 'flex',
    },
  },
});

export const hideOnDesktopGrid = style({
  display: 'none',
  '@media': {
    '(max-width: 767px)': {
      display: 'grid',
    },
  },
});

export const carouselContainerMobileRow = style({
  '@media': {
    '(max-width: 767px)': {
      flexDirection: 'row',
    },
  },
});

globalStyle(`${carouselContainerMobileRow} > *:first-child`, {
  '@media': {
    '(max-width: 767px)': {
      flex: 1,
    },
  },
});

export const carouselContainerMobileRowReverse = style({
  '@media': {
    '(max-width: 767px)': {
      flexDirection: 'row-reverse',
    },
  },
});

globalStyle(`${carouselContainerMobileRowReverse} > *:first-child`, {
  '@media': {
    '(max-width: 767px)': {
      flex: 1,
    },
  },
});

export const carouselContainerMobileColumn = style({
  '@media': {
    '(max-width: 767px)': {
      flexDirection: 'column',
    },
  },
});

export const carouselContainerMobileColumnReverse = style({
  '@media': {
    '(max-width: 767px)': {
      flexDirection: 'column-reverse',
    },
  },
});

export const carouselThumbnailsMobileVertical = style({
  '@media': {
    '(max-width: 767px)': {
      flexDirection: 'column',
      overflowX: 'visible',
      overflowY: 'auto',
      paddingBottom: 0,
      paddingRight: '0.25rem',
      height: 'var(--thumbnail-container-height-mobile, var(--thumbnail-container-height, 400px))',
      maxHeight: 'var(--thumbnail-container-height-mobile, var(--thumbnail-container-height, 400px))',
    },
  },
});

export const carouselThumbnailsMobileHorizontal = style({
  '@media': {
    '(max-width: 767px)': {
      flexDirection: 'row',
      overflowX: 'auto',
      overflowY: 'visible',
      paddingBottom: '0.25rem',
      paddingRight: 0,
      height: 'auto',
      maxHeight: 'none',
    },
  },
});

export const gridItem = style({
  position: 'relative',
  overflow: 'hidden',
  borderRadius: 'var(--carousel-border-radius, 12px)',
});

export const gridItemFullWidth = style({
  gridColumn: '1 / -1',
});

export const gridImage = style({
  width: '100%',
  height: '100%',
  display: 'block',
  borderRadius: 'var(--carousel-border-radius, 12px)',
});

export const imageLink = style({
  display: 'block',
  width: '100%',
  height: '100%',
});
